import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-matrix-3d",
  "use": "foquz-icon-question-matrix-3d-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-matrix-3d\"><path d=\"M4 10h3m-3 5h3m-3 5h3m4-15h3m4 0h3M11 9l1.5 2L14 9m-3 5l1.5 2 1.5-2m-3 5l1.5 2 1.5-2m4-10l1.5 2L21 9m-3 5l1.5 2 1.5-2m-3 5l1.5 2 1.5-2\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol